import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey, getNetworkKey, getUpsertThemeKey, } from '../../utils/keys';
import { authTokenUpdater, networkUpdater } from '../cache/useCachedNetwork';
export const useUpsertTheme = (options) => {
    const { useMutationOptions, fields } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const networkKey = getNetworkKey();
    const authTokenKey = getAuthTokensKey();
    const upsertThemeKey = getUpsertThemeKey();
    return useMutation((input) => client.theme.upsert(input, fields), {
        onMutate: async (newTheme) => {
            var _a;
            const snapshot = queryClient.getQueryData(networkKey);
            if ((_a = newTheme.input) === null || _a === void 0 ? void 0 : _a.active) {
                await queryClient.cancelQueries(networkKey);
                queryClient.setQueryData(networkKey, networkUpdater({ activeTheme: newTheme.input }));
                queryClient.setQueryData(authTokenKey, authTokenUpdater({
                    network: { activeTheme: newTheme.input },
                }));
            }
            return { snapshot };
        },
        onSuccess: newTheme => {
            queryClient.setQueryData(upsertThemeKey, networkUpdater({ activeTheme: newTheme }));
            queryClient.setQueryData(authTokenKey, authTokenUpdater({
                network: { activeTheme: newTheme },
            }));
        },
        onError: (err, newTheme, context) => {
            queryClient.setQueryData(networkKey, context.snapshot);
            queryClient.setQueryData(authTokenKey, authTokenUpdater({ network: context.snapshot }));
            queryClient.invalidateQueries(networkKey);
        },
        mutationKey: upsertThemeKey,
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpsertTheme.js.map